import script from "./CompanyLogos.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyLogos.vue?vue&type=script&setup=true&lang=js"

import "./CompanyLogos.vue?vue&type=style&index=0&id=8fae13f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fae13f8"]])

export default __exports__